







































































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import helperFormat from '../../mixins/HelperFormat.vue'

@Component
export default class DialogInfo extends Mixins(helperFormat) {

    @Prop(Boolean) show!: boolean
    @Prop() data!: any
}
